import { Component, ViewChild, ViewContainerRef, AfterViewInit, ViewChildren, AfterViewChecked } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FilterOptions } from './datagrid.component';
import { FormGroup, FormControl } from '@angular/forms';
import { FormItem } from '../form/FormItem';
import { FieldTypes } from '../../FieldTypes';

@Component({
  selector: 'vias-editor-cell',
  template: `<vias-autocomplete #filterSelect [form]="form" [item]="item" (onchange)="onChange($event)"></vias-autocomplete>`,
})
export class EditorAutoCompleteComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: any;
  public text: string = '';
  public value: number = -1;
  private options: Array<FilterOptions>;
  form: FormGroup;
  item: FormItem;

  options2: string[] = ['One', 'Two', 'Three'];

  @ViewChild('filterSelect', { read: ViewContainerRef, static: true }) public filterSelect;
  agInit(params): void {
    this.form = new FormGroup({ filterSelect: new FormControl() });
    this.item = {
      type: FieldTypes.AutoComplete,
      name: 'filterSelect',
      value: this.value,

    };
    this.params = params;
    if (params.colDef.filterParams !== null) {
      this.options = params.colDef.filterParams.filterDataSource as Array<FilterOptions>;
    }
    this.value = params.value;
  }
  ngAfterViewInit(): void {
    this.item.options = [];
    this.options.forEach(o => {
      this.item.options.push(
        {
          label: o.label,
          data: o.value.toString()
        }
      );
    });
    // window.setTimeout(() => {
    //     console.log("asads2",this.theSelect);
    //     // this.theSelect.element.nativeElement.focus();
    // },500);
  }

  afterGuiAttached?(): void {
    this.filterSelect.element.nativeElement.focus();
    console.log(this.filterSelect);
  }
  onChange(newValue): void {
    console.log('+___+');
    // this.theSelect.element.nativeElement.value;
    if (newValue !== undefined){
      if (this.value !== newValue) {
        this.value = newValue;
      }
    }
  }
  getValue(): any {
    return this.value;
  }

  isPopup(): boolean {
    return false;
  }
}
